import { Injectable } from '@angular/core';
import {
  AssociationContentType,
  AssociationContentTypeEnum,
} from '@app/channel/channel-associations-api';
import {
  AssociationList,
  BundleGroupItem,
  BundleOrgItem,
  GroupServerItem,
  OrgServerItem,
} from '../channel-associations-api';

@Injectable({
  providedIn: 'root',
})
export class ChannelAddAssociationService {
  // Shared data state for various components and modals.
  public lists: AssociationList = {
    group: [],
    bundle: [],
  };
  public containerId: number = undefined;

  constructor() {}

  public getList<T>(listName: AssociationContentType): T[] {
    if (this.lists[listName]?.length) {
      return (this.lists[listName] as unknown) as T[];
    }
    return [];
  }

  public getSelectedItems(
    items: (BundleGroupItem | BundleOrgItem)[],
    type: AssociationContentType
  ): number[] {
    const propName =
      type === AssociationContentTypeEnum.Group ? 'groupId' : 'organizationId';
    return items
      .filter(({ isSelected }) => !!isSelected)
      .map((item) => item[propName]);
  }

  public updateList<T>(
    listName: AssociationContentType,
    items: T[],
    containerId: number
  ) {
    this.containerId = containerId;
    // match types precisely so TypeScript won't complain
    if (listName === AssociationContentTypeEnum.Group) {
      this.lists.group = (items as unknown) as GroupServerItem[];
      return;
    }
    this.lists.bundle = (items as unknown) as OrgServerItem[];
  }
}
